export default __webpack_public_path__ + "static/media/zelle.d72ee90e.svg";